import client, { databases, DATABASE_ID } from './client';

export const GAME_LOUNGE_COLLECTIONS = {
  appState: 'app_state'
};

const APP_STATE_DOCUMENT_ID = 'main';

const parseJsonField = (value, fallback) => {
  if (!value) return fallback;

  try {
    return JSON.parse(value);
  } catch (error) {
    console.error('❌ Appwrite JSON-Feld konnte nicht gelesen werden:', error);
    return fallback;
  }
};

const normalizeAppStateDocument = (document) => {
  if (!document) return null;

  return {
    rooms: parseJsonField(document.rooms, []),
    orders: parseJsonField(document.orders, []),
    kioskItems: parseJsonField(document.kiosk_items, []),
    settings: parseJsonField(document.settings, {})
  };
};

const serializeGameLoungeState = (state) => ({
  key: APP_STATE_DOCUMENT_ID,
  rooms: JSON.stringify(state.rooms || []),
  orders: JSON.stringify(state.orders || []),
  kiosk_items: JSON.stringify(state.kioskItems || []),
  settings: JSON.stringify(state.settings || {}),
  updated_at: new Date().toISOString()
});

export const loadGameLoungeState = async () => {
  try {
    const document = await databases.getDocument(
      DATABASE_ID,
      GAME_LOUNGE_COLLECTIONS.appState,
      APP_STATE_DOCUMENT_ID
    );

    return normalizeAppStateDocument(document);
  } catch (error) {
    if (error?.code === 404) return null;
    throw error;
  }
};

export const saveGameLoungeState = async (state) => {
  const payload = serializeGameLoungeState(state);

  try {
    const document = await databases.updateDocument(
      DATABASE_ID,
      GAME_LOUNGE_COLLECTIONS.appState,
      APP_STATE_DOCUMENT_ID,
      payload
    );

    return normalizeAppStateDocument(document);
  } catch (error) {
    if (error?.code !== 404) throw error;
  }

  try {
    const document = await databases.createDocument(
      DATABASE_ID,
      GAME_LOUNGE_COLLECTIONS.appState,
      APP_STATE_DOCUMENT_ID,
      payload
    );

    return normalizeAppStateDocument(document);
  } catch (error) {
    if (error?.code === 409) {
      const document = await databases.updateDocument(
        DATABASE_ID,
        GAME_LOUNGE_COLLECTIONS.appState,
        APP_STATE_DOCUMENT_ID,
        payload
      );

      return normalizeAppStateDocument(document);
    }

    throw error;
  }
};

export const subscribeGameLoungeState = (onStateChange) => {
  try {
    return client.subscribe(
      `databases.${DATABASE_ID}.collections.${GAME_LOUNGE_COLLECTIONS.appState}.documents.${APP_STATE_DOCUMENT_ID}`,
      (response) => {
        const nextState = normalizeAppStateDocument(response.payload);
        if (nextState) onStateChange(nextState);
      }
    );
  } catch (error) {
    console.error('❌ Appwrite Realtime konnte nicht gestartet werden:', error);
    return () => {};
  }
};
